import { CustomConfirmDialogComponent } from "./../../../shared/components/custom-confirm-dialog/custom-confirm-dialog.component";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { ITableColumnHeader } from "src/app/models/table-column-header";
import { ApiService } from "src/app/providers/api.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { NavigationService } from "src/app/providers/navigation.service";
import { AddOtherExpensesComponent } from "src/app/shared/components/add-other-expenses/add-other-expenses.component";
import { AddServiceTemplateItemComponent } from "src/app/shared/components/add-service-template-item/add-service-template-item.component";
import { InventoryItemsForMiscComponent } from "src/app/shared/components/inventory-items-for-misc/inventory-items-for-misc.component";
import { InventoryItemsForPurchaseComponent } from "src/app/shared/components/inventory-items-for-purchase/inventory-items-for-purchase.component";
import { SalaryForExpenseComponent } from "src/app/shared/components/salary-for-expense/salary-for-expense.component";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { YoutubeEmbedVideoComponent } from "../../new-v2-pages/new-v2-component/youtube-embed-video/youtube-embed-video.component";
import { DialogService } from "src/app/providers/dialog.service";

@Component({
  selector: "sm-expenses",
  templateUrl: "./expenses.component.html",
  styleUrls: ["./expenses.component.scss"],
})
export class ExpensesComponent implements OnInit, OnDestroy {
  overview: any;
  monthExpense: number = 0;
  dailyExpense: number = 0;
  expenseListData: any[] = [];
  tableDisplayColumn: ITableColumnHeader[] = [
    {
      columnName: this.translateService.instant("expenses.column_headers.date"),
      columnProperty: "expenseDatetime",
    },
    {
      columnName: this.translateService.instant("expenses.column_headers.name"),
      columnProperty: "label",
    },
    {
      columnName: this.translateService.instant(
        "expenses.column_headers.notes"
      ),
      columnProperty: "reason",
    },
    {
      columnName: "Amount",
      columnProperty: "pprice",
    },

    // {
    //   columnName: "status",
    //   columnProperty: "p_status"
    // },
    // {
    //   columnName: "activity type",
    //   columnProperty: "activity_type"
    // }
  ];
  entityHashId: string = "";
  entityHashIdForSearch: string = "";
  datalength!: number;
  public page: number = 1;
  public loader: boolean = false;
  _apiSubscription: Subscription;
  constructor(
    private _navService: NavigationService,
    private dialog: MatDialog,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private _apiService: ApiService,
    private loaderservice: LoaderServiceService,
    private route: ActivatedRoute,
    private _modelRef: MatDialog,
    private translateService: TranslateService,
    private dialogService:DialogService
  ) {
    this._navService.hideSidebarAndNav = false;

    this._apiSubscription = this._apiService.apiResult.subscribe((resData) => {
      if (resData) {
        console.log(resData);

        // console.log(resData.responseType === SM_CONSTANTS.RESULT_API_ENTITY_EXPENSES_OVERVIEW);

        if (
          resData.responseType === SM_CONSTANTS.RESULT_API_GET_EXPENSES_LIST
        ) {
          this.expenseListData = [];
          if (resData.result && resData.result != "null") {
            this.expenseListData = resData.result;
            this.expenseListData = resData.result.map((item: any) => {
              // Creating a new object with all the same keys and values
              const newItem = { ...item };

              // Adding a new custom key with a custom value
              newItem.pprice = item.currency_symbol + (item.amount ? item.amount.toFixed(2) : '0.00');

              return newItem;
            });
          }

          this.loader = false;
          this.loaderservice.showLoader = false;
        } else if (
          resData.responseType === SM_CONSTANTS.RESULT_API_UPDATE_EXPENSE_INFO
        ) {
          if (resData.result && resData.result != null) {
            this.page = 1;
            this._apiService.getExpensesList(this.page.toString());
            this._apiService.getEntityExpenseOverview(this.entityHashId);
          }
        } else if (
          resData.responseType ===
          SM_CONSTANTS.RESULT_API_ADD_EDIT_PURCHASE_ITEM
        ) {
          if (resData.result && resData.result != null) {
            this._apiService.getEntityExpenseOverview(this.entityHashId);
            this._apiService.getExpensesList(this.page.toString());
          }
        } else if (
          resData.responseType === SM_CONSTANTS.RESULT_API_UPDATE_SALARY_INFO
        ) {
          if (resData.result && resData.result != null) {
            this._apiService.getEntityExpenseOverview(this.entityHashId);
            this._apiService.getExpensesList(this.page.toString());
          }
        }
        if (
          resData.responseType ===
          SM_CONSTANTS.RESULT_API_ENTITY_EXPENSES_OVERVIEW
        ) {
          console.log("trigger");
          this.overview = null;
          if (resData.result && resData.result != null) {
            this.overview = resData.result[0];
            // this._apiService.getEntityPurchaseItems(this.entityHashId, this.page.toString())
            this.monthExpense = resData.result[0].monthExpense ?? 0;
            this.dailyExpense = resData.result[0].dailyExpense ?? 0;
          }
          console.log(this.overview);
        }

        this.translateService.onLangChange.subscribe(() => {
          // Update your column headers when the language changes
          this.updateColumnHeaders();
        });
      }
    });
  }
  private updateColumnHeaders() {
    this.tableDisplayColumn.forEach((column, index) => {
      let data = ["date", "name", "notes", "amount"];
      // Update each column header with the translated value
      column.columnName = this.translateService.instant(
        `expenses.column_headers.${data[index]}`
      );
    });
  }
  ngOnInit(): void {
    this.loader = true;
    this.loaderservice.showLoader = true;
    this.route.queryParams.subscribe((data) => {
      console.log(data.entityHash);
      this.entityHashId = data.entityHash;
      // this.entityHashIdForSearch = data.entityHash
    });
    this._apiService.getEntityExpenseOverview(this.entityHashId);
    this._apiService.getExpensesList(this.page.toString());
  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
  }
  deleteExpense(rowvalue: any) {
    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
      width: "400px",
      data: {
        title: "Alert",
        message: "Are you sure you want to delete this expense data?",
        okbtn: "Yes",
        cancelbtn: "No",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      console.log(result);
      if (result) {
        let data = {
          expenseInfo: {
            hash_id: rowvalue.hash_id,
            isDelete: 1,
          },
        };

        this.loaderservice.showLoader = true;
        this._apiService.updateExpenseInfo(data);
      }
    });
  }

  openEmloyees() {
    // this.router.navigate(["/businesses", "details", "employees"], {
    //   queryParams: { entityHash: this.entityHashId },
    // });
    let data = {
      title: "Employee Salary",
      operation_type: 1,
      ref: this._modelRef,
      toShowTemplate: true,
    }
    this.dialogService.openFullScreenDialog(SalaryForExpenseComponent,data);
  }
  openPurchases() {
    // this.router.navigate(["/businesses", "details", "purchase-list"], {
    //   queryParams: {
    //     entityHash: this.entityHashId,
    //   },
    // });
    let data = {
      title: "Inventory items",
      operation_type: 1,
      ref: this._modelRef,
      toShowTemplate: true,
    } 
    this.dialogService.openFullScreenDialog(InventoryItemsForPurchaseComponent,data);
  }
  onOtherExpenses() {
    let data = {
      title: "Enter the expense data",
      ref: this._modelRef,
    }
    this.dialogService.openFullScreenDialog(AddOtherExpensesComponent,data);
  }
  openInventoryItems() {
    this._modelRef.open(InventoryItemsForPurchaseComponent, {
      // width: '1000px',
      // minWidth: "400px",
      data: {
        title: "Inventory items",
        operation_type: 1,
        ref: this._modelRef,
        toShowTemplate: true,
      },
      // disableClose : true
    });
  }

  onPageChange(ev: any) {
    console.log(ev?.pageIndex + 1);
    this.page = ev?.pageIndex + 1;

    this._apiService.getEntityInventoryInOutData(
      this.entityHashId,
      this.page.toString()
    );
  }

  // onRecordUsageAndFinish(){
  //   // this.loaderservice.showLoader = true;
  //   this._modelRef.open(InventoryItemsForMiscComponent, {
  //         width: '1000px',
  //         minWidth: "400px",
  //         data: {
  //           title: 'Record usage/finish',
  //           ref: this._modelRef,
  //         },
  //       });
  //     }
  onRevertUsage(rowvalue: any) {
    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
      width: "400px",
      data: {
        title: "Alert",
        message:
          "This will remove the usage record and increase the stock as well. Are you sure you want to continue?",
        okbtn: "Yes",
        cancelbtn: "No",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      console.log(result);
      if (result) {
        let bodyData = {
          entity_hash_id: this.entityHashId,
          itemHashId: rowvalue.item_hash_id,
          activityHashId: rowvalue.hash_id,
        };
        // this.loader = true;
        this.loaderservice.showLoader = true;
        this._apiService.editInventoryActivity(bodyData);
      }
    });
  }

  onRecordUsage() {
    this._modelRef.open(InventoryItemsForMiscComponent, {
      // width: '1000px',
      // minWidth: "400px",
      data: {
        title: "Inventory items",
        operation_type: 2,
        ref: this._modelRef,
        toShowTemplate: true,
      },
      disableClose: true,
    });
  }

  onEdit(rowvalue: any) {
    this._modelRef.open(InventoryItemsForPurchaseComponent, {
      // width: '1000px',
      // minWidth: "400px",
      data: {
        title: "Purchase Item",
        operation_type: 2, //edit
        ref: this._modelRef,
        purchaseData: rowvalue,
        toShowTemplate: true,
      },
      disableClose: true,
    });
  }
  markPurchased(rowvalue: any) {
    this._modelRef.open(InventoryItemsForPurchaseComponent, {
      // width: '1000px',
      // minWidth: "400px",
      data: {
        title: "Purchase Item",
        operation_type: 3, //mark purchased
        ref: this._modelRef,
        purchaseData: rowvalue,
        toShowTemplate: true,
      },
      disableClose: true,
    });
  }
  OnIncreaseStock() {
    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
      width: "500px",
      data: {
        title: "Alert",
        message:
          "Stock update will only increase your initial item quantity counts. It's not going to add any purchase/price related data. If you have purchased the item(s), add the record from the Purchase section.",
        okbtn: "Confirm",
        cancelbtn: "Cancel",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      console.log(result);
      if (result) {
        this._modelRef.open(InventoryItemsForMiscComponent, {
          // width: '1000px',
          // minWidth: "400px",
          data: {
            title: "Inventory items",
            operation_type: 1,
            ref: this._modelRef,
            toShowTemplate: true,
          },
          disableClose: true,
        });
      }
    });
  }

  onPurchasePending(rowvalue: any) {
    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
      width: "500px",
      data: {
        title: "Alert",
        message:
          "Are you sure you want to change the status of this purchase to pending? Your inventory stock count may be affected if it was previously marked purchased.",
        okbtn: "Confirm",
        cancelbtn: "Cancel",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      console.log(result);
      if (result) {
        let bodydata = {
          hash_id: rowvalue.purchase_hash_id,
          entity_hash_id: rowvalue.entity_hash_id,
          inv_item_hash: rowvalue.inventory_item_hash_id,
          purchase_qty: rowvalue.purchase_quantity,
          purchase_unit: rowvalue.purchase_unit,
          purchase_status: 2, //1 = purchase, 2=reminder,3 = cancelled,0=delete
          purchase_price: rowvalue.purchase_price,
          notes: rowvalue.notes,
          status: rowvalue.status,
          purchase_date: this.formatDate(
            new Date(rowvalue.purchase_date).toLocaleDateString()
          ),
        };

        this.loaderservice.showLoader = true;
        this._apiService.addEditPurchaseItem(bodydata);
      }
    });
  }
  onPurchaseCancelled(rowvalue: any) {
    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
      width: "500px",
      data: {
        title: "Alert",
        message:
          "Are you sure you want to cancel this item from purchase list?",
        okbtn: "Yes",
        cancelbtn: "No",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      console.log(result);
      if (result) {
        let bodydata = {
          hash_id: rowvalue.purchase_hash_id,
          entity_hash_id: rowvalue.entity_hash_id,
          inv_item_hash: rowvalue.inventory_item_hash_id,
          purchase_qty: rowvalue.purchase_quantity,
          purchase_unit: rowvalue.purchase_unit,
          purchase_status: 3, //1 = purchase, 2=reminder,3 = cancelled,0=delete
          purchase_price: rowvalue.purchase_price,
          notes: rowvalue.notes,
          status: rowvalue.status,
          // "purchase_date": this.formatDate(new Date(rowvalue.purchase_date).toLocaleDateString())
        };

        this.loaderservice.showLoader = true;
        this._apiService.addEditPurchaseItem(bodydata);
      }
    });
  }
  onPurchaseDeleted(rowvalue: any) {
    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
      width: "500px",
      data: {
        title: "Alert",
        message:
          "Are you sure you want to delete this item from purchase list?",
        okbtn: "Confirm",
        cancelbtn: "Cancel",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      console.log(result);
      if (result) {
        let bodydata = {
          hash_id: rowvalue.purchase_hash_id,
          entity_hash_id: rowvalue.entity_hash_id,
          inv_item_hash: rowvalue.inventory_item_hash_id,
          purchase_qty: rowvalue.purchase_quantity,
          purchase_unit: rowvalue.purchase_unit,
          purchase_status: 0, //1 = purchase, 2=reminder,3 = cancelled,0=delete
          purchase_price: rowvalue.purchase_price,
          notes: rowvalue.notes,
          status: rowvalue.status,
          // "purchase_date": this.formatDate(new Date(rowvalue.purchase_date).toLocaleDateString())
        };

        this.loaderservice.showLoader = true;
        this._apiService.addEditPurchaseItem(bodydata);
      }
    });
  }

  formatDate(dateStr: string) {
    // Split the date string by `/`
    const parts = dateStr.split("/");

    // Reverse the order of the parts and join them with `-`
    const newDateStr = parts.reverse().join("-");

    // Return the formatted date string
    return newDateStr;
  }

  openLink(url: string): void {
    window.open(url, "_blank");
  }
  openvideo() {
    this.dialog.open(YoutubeEmbedVideoComponent, {
      width: "1000px",
      disableClose: true,
      data: {
        link: "",
        title: "Business profile",
      },
    });
  }

  opencontact() {
    this.router.navigate(["/contact-us"]);
  }
}
